import {workingSet} from './mergeContext';
import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from '../find';
import InvoiceBatchItem from '../../entities/invoiceBatchItem';
import InvoiceBatch from '../../entities/invoiceBatch';
import {canCascadeDelete, addDeleteImpact, deleteImpactContext, deleteImpactCounts, workingRows, enqueueDelete} from './deleteContext';
import type {DeleteImpact, DeleteImpactContext, DeleteResult, DeleteTraversal} from './deleteContext';
export function canDeleteInvoiceBatchItem(): boolean {
return true;
}
export function collectInvoiceBatchItemDeleteImpact(invoiceBatchItem: InvoiceBatchItem, context: DeleteImpactContext): void {
const key = 'invoiceBatchItem:' + invoiceBatchItem.id;
if (context.visited.has(key)) return;
context.visited.add(key);
const state = store.getState();
const invoiceBatchInvoiceBatchItemIdsImpact = workingRows<InvoiceBatch>('invoiceBatch', findAll<InvoiceBatch>('invoiceBatches')).filter(invoiceBatchRef => invoiceBatchRef.invoiceBatchItemIds?.includes(invoiceBatchItem.id));
invoiceBatchInvoiceBatchItemIdsImpact.forEach(invoiceBatchRef => addDeleteImpact(context, 'invoiceBatch:' + invoiceBatchRef.id, 'invoiceBatches'));}
export function deleteImpactInvoiceBatchItem(invoiceBatchItem: InvoiceBatchItem): DeleteImpact {
const context = deleteImpactContext();
collectInvoiceBatchItemDeleteImpact(invoiceBatchItem, context);
return deleteImpactCounts(context);
}
export function deleteInvoiceBatchItem(invoiceBatchItem: InvoiceBatchItem, mergeId?: string, cascade?: DeleteTraversal): DeleteResult {
if (!cascade) {
if (!canDeleteInvoiceBatchItem()) return {status: 'notReady', impacts: []};
const context = deleteImpactContext();
collectInvoiceBatchItemDeleteImpact(invoiceBatchItem, context);
if (context.blocked) return {status: 'blocked', impacts: deleteImpactCounts(context)};
cascade = {visited: new Set(), importSource: mergeId ? 'merge' : 'delete', importId: mergeId || invoiceBatchItem.id};
}
const key = 'invoiceBatchItem:' + invoiceBatchItem.id;
if (cascade.visited.has(key)) return {status: 'deleted', impacts: []};
cascade.visited.add(key);
const targetImportSource = cascade.importSource;
mergeId = cascade.importId;
const _work = workingSet();
const dispatch = (action: any, key: string) => enqueueDelete(_work, onQueued => store.dispatch({...action, onQueued: (saved: boolean) => onQueued(saved, action.type.endsWith('_REMOVE_QUEUE'))}), () => _work.delete(key));
workingRows<InvoiceBatch>('invoiceBatch', [...store.getState().invoiceBatches.getMappingFor('invoiceBatchItemId', invoiceBatchItem.id)]).filter(invoiceBatchTemp => invoiceBatchTemp.invoiceBatchItemIds?.includes(invoiceBatchItem.id)).forEach(invoiceBatchTemp => {
const _invoiceBatch = ((_work.get('invoiceBatch:' + invoiceBatchTemp.id) ?? invoiceBatchTemp) as InvoiceBatch).clone();
if (_invoiceBatch.status === 'D') return;
_invoiceBatch.status = 'U';
_invoiceBatch.addedOn = newHRTimestamp();
_invoiceBatch.addedBy = getCurrentUserId();
_invoiceBatch.importSource = targetImportSource;
_invoiceBatch.importId = mergeId;
_invoiceBatch.invoiceBatchItemIds = _invoiceBatch.invoiceBatchItemIds?.filter(id => id !== invoiceBatchItem.id) || [];

_work.set('invoiceBatch:' + _invoiceBatch.id, _invoiceBatch);
dispatch(Actions.InvoiceBatchActions.saveInvoiceBatchQueue(_invoiceBatch), 'invoiceBatch:' + _invoiceBatch.id);
});
const deleted = invoiceBatchItem.clone();
deleted.status = 'D';
deleted.addedOn = newHRTimestamp();
deleted.addedBy = getCurrentUserId();
deleted.importSource = targetImportSource;
deleted.importId = mergeId;
_work.set(key, deleted);
const completion = dispatch(Actions.InvoiceBatchItemActions.removeInvoiceBatchItemQueue(deleted), key);
return {status: 'deleted', impacts: [], completion};
}

export function replaceInvoiceBatchItem(invoiceBatchItem: InvoiceBatchItem, replaceWith: InvoiceBatchItem, mergeId?: string) {
let targetImportSource = 'merge';
if (!mergeId) {targetImportSource = 'delete';mergeId = invoiceBatchItem.id;}
const _work = workingSet();
workingRows<InvoiceBatch>('invoiceBatch', [...store.getState().invoiceBatches.getMappingFor('invoiceBatchItemId', invoiceBatchItem.id)]).filter(invoiceBatchTemp => invoiceBatchTemp.invoiceBatchItemIds?.includes(invoiceBatchItem.id)).forEach(invoiceBatchTemp => {
const _invoiceBatch = ((_work.get('invoiceBatch:' + invoiceBatchTemp.id) ?? invoiceBatchTemp) as InvoiceBatch).clone();
if (_invoiceBatch.status === 'D') return;
_invoiceBatch.status = 'U';
_invoiceBatch.addedOn = newHRTimestamp();
_invoiceBatch.addedBy = getCurrentUserId();
_invoiceBatch.importSource = targetImportSource;
_invoiceBatch.importId = mergeId;
_invoiceBatch.invoiceBatchItemIds = _invoiceBatch.invoiceBatchItemIds?.map(id => (id === invoiceBatchItem.id) ? replaceWith.id : id) || [];

_work.set('invoiceBatch:' + _invoiceBatch.id, _invoiceBatch);
store.dispatch(Actions.InvoiceBatchActions.saveInvoiceBatchQueue(_invoiceBatch));
});



return invoiceBatchItem;
}
